import { AxiosResponse } from "axios";
import instance from "../instance";

export const getDownloadLink = async (
  id: number,
  type: string = "order_message"
): Promise<{ url: string }> => {
  try {
    const res: AxiosResponse<{ url: string }> = await instance.get(
      `/v1/download`,
      {
        params: { id, type },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
